import React from "react";
import Box from "@material-ui/core/Box";


class TabPanel extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div
                role="tabpanel"
                hidden={this.props.value !== this.props.index}
                id={`vertical-tabpanel-${this.props.index}`}
                aria-labelledby={`vertical-tab-${this.props.index}`}
                style={{"width": "100%"}}
            >
                {this.props.value === this.props.index && (
                    <Box p={1}>
                        {this.props.children}
                    </Box>
                )}
            </div>
        );
    }
}

export default TabPanel;